// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__YMx1z","spin":"Spinner_spin__wzXeB","container":"Spinner_container__SM5eO"};